import { render } from "./radio.vue?vue&type=template&id=a4f715d0&scoped=true"
import script from "./radio.vue?vue&type=script&lang=js"
export * from "./radio.vue?vue&type=script&lang=js"

import "./radio.vue?vue&type=style&index=0&id=a4f715d0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a4f715d0"

export default script